/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Workshopdate1Inputs */

const de__field_workshopdate1 = /** @type {(inputs: _Field_Workshopdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung/Workshop Teilnahme/Durchführung Datum`)
};

/**

* @param {_Field_Workshopdate1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_workshopdate1 = /** @type {((inputs?: _Field_Workshopdate1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Workshopdate1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_workshopdate1(inputs)
});
export { _field_workshopdate1 as "_field_workshopDate" }